import type { TOC } from '@ember/component/template-only';
import type { ConditionExtension as ConditionModel } from 'tio-data/data/resources/condition.ext';
import { t } from 'ember-intl';

interface S {
  Args: {
    conditions: ReadonlyArray<ConditionModel>;
  };
}

const TasProgramTemplateReviewTermsAndConditionsTable: TOC<S> = <template>
  {{#if @conditions}}
    <div class="grid grid-cols-4 md:grid-cols-7 gap-4 font-semibold tio-bg-info-soft p-4">
      <span class="col-span-1">
        {{t "common.tuition_assistance.program_template_review.type"}}
      </span>
      <span class="col-span-1">
        {{t "common.prompt"}}
      </span>
      <div class="col-span-5"></div>
    </div>

    <div class="grid grid-cols-4 md:grid-cols-7 gap-2 p-4">
      {{#each @conditions as |condition|}}
        <div class="col-span-1">
          {{t "common.tuition_assistance.program_template_review.accept_conditions"}}
        </div>
        <div class="col-span-1">
          {{condition.prompt}}
        </div>
        <div class="col-span-1">
          {{#if condition.hasPdf}}
            <span class="app-solid-badge app-solid-badge--brand">
              {{t "common.pdf"}}
            </span>
          {{/if}}
        </div>
      {{/each}}
    </div>
  {{else}}
    <p class="text-sm my-2">{{t "common.none"}}</p>
  {{/if}}
</template>;

export default TasProgramTemplateReviewTermsAndConditionsTable;
